import Blog from "../models/blog";
import Template from "../models/template";

export const blogs: Blog[] = [
    {
        title: "Küche",
        handle: "rezepte",
        id: 49107009599
    },
    {
        title: "Quick Tipps",
        handle: "quick-tipps",
        id: 77169328191
    },
    {
        title: "Alltag",
        handle: "alltag",
        id: 77169721407
    },
    {
        title: "Jahreszeit",
        handle: "jahreszeit",
        id: 77169754175
    },
    {
        title: "Beauty",
        handle: "beauty",
        id: 77169197119
    },
    {
        title: "Kuren",
        handle: "kuren",
        id: 77169786943
    },
    {
        title: "Spa",
        handle: "spa",
        id: 77169819711
    },
    {
        title: "Downloads",
        handle: "downloads",
        id: 77169852479
    },
];

export const templates: Template[] = [
    {
        title: "SEO",
        handle: "seo"
    },
    {
        title: "SEO - Ohne Logo",
        handle: "seo.hide"
    },
    {
        title: "Tropfen",
        handle: "tropfen"
    },
    {
        title: "Tropfen Set",
        handle: "tropfen.set"
    },
    {
        title: "Kapseln",
        handle: "kapseln"
    },
    {
        title: "Tee",
        handle: "tee"
    },
    {
        title: "Pulver",
        handle: "pulver"
    },
    {
        title: "Vitamin-C Kapseln",
        handle: "vitaminc"
    },
];

export const HOST = "https://bitterliebe-backend.herokuapp.com";
//export const HOST = "http://localhost:3001";

export const ASSETS = {
    watch: "https://cdn.shopify.com/s/files/1/0248/6583/3023/files/watch.png?v=1618235414",
    difficulty_icon: "https://cdn.shopify.com/s/files/1/0248/6583/3023/files/icon.jpg?v=1618235414",
    difficulty_icon_filled: "https://cdn.shopify.com/s/files/1/0248/6583/3023/files/icon_filled.png?v=1618235414"
}
